import { Button } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react'
import { Crafting } from './Crafting';
import { ViewInventario } from './ViewInventario';
import fondo from '../../../Web Mundo/fondoCrafting.png'
import { Marketlace } from '../../market/Market';
import { SpecialMarket } from '../../market/SpecialMarket';

//const fondo = 'https://res.cloudinary.com/dbav8xw6s/image/upload/f_auto,q_23/v1669377771/FONDOS%20NAVIDE%C3%91OS/Fondo_navidad_1_znbszd.png'

export const Album = () => {
  const [paginas, setPaginas] =  useState(5)
  const [evento, setEvento] = useState('') 
  const [nft, setNft] = useState(false) 
  const [rareza, setRareza] = useState('todas')
  

  const  handleEvento = (e) => {
    setEvento(e)
  }
  const handleChange = (e) => {
    setRareza(e.target.value)
    
  }
  return (
    <Box sx={{backgroundImage: `url(${fondo})`, display:'flex',  width: '100%', height: {xs: '100%', md: '95vh'}, backgroundPosition: 'bottom', backgroundSize: 'cover'}}>
      <Box  sx={{ width: {sm: '40%', lg: '20%'}, marginRight:1 }}>
        
        <Box sx={{ width: '100%' ,display: "flex", height: "100%" , overflow: 'hidden'}}>
          <Box sx={{ width: {sm: "100%" }, height: "100%" }}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "10px",
                padding: "10px",
                display: "flex",
                
                alignItems: "center",
                backgroundColor: "rgba(255,200,200,0.2)",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60px",
                  position: 'relative',
                  zIndex: '1000'
                }}
              >
                <Button onClick={()=> setPaginas(4)}>Marketplace</Button>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60px",
                }}
              >
                <Button onClick={()=> setPaginas(1)}>General Album</Button>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60px",
                }}
              >
                <Button onClick={()=> setPaginas(2)}>Special Album</Button>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60px",
                }}
              >
                <Button onClick={()=> setPaginas(3)}> Crafting</Button>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60px",
                }}
              >
                <Button onClick={()=> setPaginas(5)}> Special Market</Button>
              </Box>
           <Box
                      sx={{
                        borderBottom: "1px solid gray",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "60px",
                      }}
                    >
                      <a style={{fontStyle: "none", textDecoration: "none", color: "white"}} href='https://hivenfts.com/big-dog-bone/buy/' target='_blank'> Secondary Market </a>
                    </Box>
            </Box>
          </Box>
     
        </Box>
      </Box>
      <Box sx={{ width: '90%', overflow: 'hidden', height: '80%'  ,  overflow: 'hidden'}}>
                {paginas  <= 2 && <ViewInventario paginas={paginas} /> }
                {paginas  === 3 && <Crafting  /> }
                {paginas  === 4 && <Marketlace  /> }
                {paginas  === 5 && <SpecialMarket  /> }

                
            
            </Box>
    </Box>
  );
};
